<template>
  <v-data-table :headers="headers" :items="items" sort-by="no" @click:row="onClickRow">
    <template v-slot:top>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <v-btn color="success" dark rounded :to="{ name: 'Create Bank Guarantee' }">
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.no="{ item }">
      {{ items.findIndex(x => x === item) + 1 }}
    </template>
    <template v-slot:item.totalPo="{ item }">
      {{ formatPrice(item.totalPo) }}
    </template>
    <template v-slot:item.totalMargin="{ item }">
      {{ formatPrice(item.totalMargin) }}
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  data: () => ({
    headers: [
      {
        text: "No",
        align: "start",
        sortable: false,
        value: "no",
      },
      { text: "PO#", value: "poNumber", sortable: false },
      { text: "Type Transaction", value: "typeTransaction", sortable: false },
      { text: "Type", value: "typeGuarantee", sortable: false },
      { text: "Guarantee Name", value: "typeGuaranteeName", sortable: false },
      { text: "Total PO", value: "totalPo", sortable: false },
      { text: "Total Margin", value: "totalMargin", sortable: false },
      { text: "Start Date", value: "startDate", sortable: false },
      { text: "End Date", value: "endDate", sortable: false },
      { text: "Status", value: "status", sortable: false },
    ],
    items: [],
  }),

  created() {
    this.initialize();
  },

  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    async initialize() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("bankGuarantee/getAll")
        .then(response => {
          this.items = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    onClickRow(item) {
      this.$router.push({ name: "Detail Bank Guarantee", params: { id: item.id } });
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>

<style></style>
